import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGetStarted = () => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/courses/html');
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="hero-section text-center my-5">
      <h1>{t('homepage.heroTitle')}</h1>
      <p>{t('homepage.heroSubtitle')}</p>
      <button className="btn btn-light btn-lg mt-3" onClick={handleGetStarted}>
        {t('homepage.getStarted')}
      </button>
    </div>
  );
};

export default Hero;
